// src/App.js - UPDATED with HOD Dashboard
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';

// Import all dashboard components
import AdminDashboard from './components/dashboards/AdminDashboard';
import StudentDashboard from './components/dashboards/StudentDashboard';
import FacultyDashboard from './components/dashboards/FacultyDashboard';
import HODDashboard from './components/dashboards/HODDashboard';
import FinanceDashboard from './components/dashboards/FinanceDashboard';
import HostelDashboard from './components/dashboards/HostelDashboard';
import LibraryDashboard from './components/dashboards/LibraryDashboard';
import TransportDashboard from './components/dashboards/TransportDashboard';
import DriverDashboard from './components/dashboards/DriverDashboard';
import Recepsonist from './components/dashboards/Recepsonist';
import ProfilePage from './components/ProfilePage';
import ChangePasswordPage from './components/ChangePasswordPage';
import LabTechnicianDashboard from './components/dashboards/LabTechnicianDashboard';
import LabBilling from './components/dashboards/LabBilling';
import ReportGeneration from './components/dashboards/ReportGeneration';
import BillingManager  from './components/dashboards/BillingManager';
import SampleCollector from './components/dashboards/SampleCollector';
import GrievanceOfficerDashboard from './components/dashboards/GrievanceOfficerDashboard';
import MyGrievancesPage          from './components/grievances/MyGrievancesPage';
import GrievanceDetailPage       from './components/grievances/GrievanceDetailPage';
import DepartmentActionPage      from './components/grievances/DepartmentActionPage';
import PrincipalDashboard from './components/dashboards/PrincipalDashboard';
import DeanDashboard from './components/dashboards/DeanDashboard';
import ParentDashboard from './components/dashboards/ParentDashboard';
import COEDashboard    from './components/dashboards/COEDashboard';
import PaperEvaluatorDashboard from './components/dashboards/PaperEvaluatorDashboard';
import AdmissionForm from './components/AdmissionForm';
import LandingPage from './components/LandingPage';

import './App.css';
import NotificationCenter from './components/shared/NotificationCenter';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app">
          <NotificationCenter />
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/admission-form" element={<AdmissionForm />} />

            {/* Profile Route - Available to all authenticated users */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />

            {/* Change Password Route - Available to all authenticated users */}
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePasswordPage />
                </ProtectedRoute>
              }
            />

            {/* Protected Routes - Role-Specific Dashboards */}
            <Route
              path="/admin-dashboard"
              element={
                <ProtectedRoute allowedRoles={['ADMIN']}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/principal-dashboard"
              element={
                <ProtectedRoute allowedRoles={['PRINCIPAL']}>
                  <PrincipalDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/dean-dashboard"
              element={
                <ProtectedRoute allowedRoles={['DEAN']}>
                  <DeanDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/student-dashboard"
              element={
                <ProtectedRoute allowedRoles={['STUDENT', 'INTERN']}>
                  <StudentDashboard />
                </ProtectedRoute>
              }
            />

            {/* HOD Dashboard - NEW */}
            <Route
              path="/hod-dashboard"
              element={
                <ProtectedRoute
                  allowedRoles={['FACULTY']}
                  requireSubrole="HEAD_OF_DEPARTMENT"
                >
                  <HODDashboard />
                </ProtectedRoute>
              }
            />

            {/* Regular Faculty Dashboard - Exclude HODs */}
            <Route
              path="/faculty-dashboard"
              element={
                <ProtectedRoute
                  allowedRoles={['FACULTY']}
                  excludeSubrole="HEAD_OF_DEPARTMENT"
                >
                  <FacultyDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/finance-dashboard"
              element={
                <ProtectedRoute allowedRoles={['FINANCE']}>
                  <FinanceDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/hostel-dashboard"
              element={
                <ProtectedRoute allowedRoles={['HOSTEL_ADMIN', 'STORE_MANAGER', 'ADMIN', 'STUDENT']}>
                  <HostelDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/library-dashboard"
              element={
                <ProtectedRoute allowedRoles={['LIBRARY_STAFF', 'ADMIN', 'STUDENT', 'FACULTY']}>
                  <LibraryDashboard />
                </ProtectedRoute>
              }
            />


            <Route
              path="/transport-dashboard"
              element={
                <ProtectedRoute allowedRoles={['TRANSPORT_MANAGER']}>
                  <TransportDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/driver-dashboard"
              element={
                <ProtectedRoute allowedRoles={['DRIVER']}>
                  <DriverDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/reception"
              element={
                <ProtectedRoute allowedRoles={['recepsonist']}>
                  <Recepsonist />
                </ProtectedRoute>
              }
            />

            <Route
              path="/lab-dashboard"
              element={
                <ProtectedRoute allowedRoles={['LAB_TECH_MICROBIOLOGY', 'LAB_TECH_PATHOLOGY', 'LAB_TECH_BIOCHEMISTRY']}>
                  <LabTechnicianDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/lab-billing"
              element={
                <ProtectedRoute allowedRoles={['BILLING_MEMBER']}>
                  <LabBilling />
                </ProtectedRoute>
              }
            />

            <Route
              path="/report-generation"
              element={
                <ProtectedRoute allowedRoles={['REPORT_GENERATION']}>
                  <ReportGeneration />
                </ProtectedRoute>
              }
            />

            {/* ── Grievance Officer Dashboard ─────────────────────────────────────────── */}
            <Route
              path="/grievance-officer-dashboard"
              element={
                <ProtectedRoute allowedRoles={['GRIEVANCE_OFFICER', 'ADMIN']}>
                  <GrievanceOfficerDashboard />
                </ProtectedRoute>
              }
            />

            {/* ── My Grievances — accessible by every role except GRIEVANCE_OFFICER ────── */}
            <Route
              path="/my-grievances"
              element={
                <ProtectedRoute allowedRoles={[
                  'STUDENT', 'FACULTY', 'FINANCE', 'HOSTEL_ADMIN', 'LIBRARY_STAFF',
                  'TRANSPORT_MANAGER', 'recepsonist', 'LAB_TECH_MICROBIOLOGY',
                  'LAB_TECH_PATHOLOGY', 'LAB_TECH_BIOCHEMISTRY', 'BILLING_MEMBER',
                  'BILLING_MANAGER', 'SAMPLE_COLLECTOR', 'REPORT_GENERATION', 'ADMIN',
                ]}>
                  <MyGrievancesPage />
                </ProtectedRoute>
              }
            />

            {/* ── Grievance Detail — accessible by submitter, dept staff, officer, admin ─ */}
            <Route
              path="/grievances/:id"
              element={
                <ProtectedRoute allowedRoles={[
                  'STUDENT', 'FACULTY', 'FINANCE', 'HOSTEL_ADMIN', 'LIBRARY_STAFF',
                  'TRANSPORT_MANAGER', 'recepsonist', 'LAB_TECH_MICROBIOLOGY',
                  'LAB_TECH_PATHOLOGY', 'LAB_TECH_BIOCHEMISTRY', 'BILLING_MEMBER',
                  'BILLING_MANAGER', 'SAMPLE_COLLECTOR', 'REPORT_GENERATION',
                  'GRIEVANCE_OFFICER', 'ADMIN',
                ]}>
                  <GrievanceDetailPage />
                </ProtectedRoute>
              }
            />

            {/* ── Department Action Page — for dept staff to handle assigned grievances ─── */}
            <Route
              path="/department-grievances"
              element={
                <ProtectedRoute allowedRoles={[
                  'BILLING_MANAGER', 'REPORT_GENERATION', 'SAMPLE_COLLECTOR',
                  'LAB_TECH_MICROBIOLOGY', 'LAB_TECH_PATHOLOGY', 'LAB_TECH_BIOCHEMISTRY',
                  'recepsonist', 'HOSTEL_ADMIN', 'LIBRARY_STAFF', 'TRANSPORT_MANAGER',
                  'FACULTY', 'FINANCE', 'ADMIN',
                ]}>
                  <DepartmentActionPage />
                </ProtectedRoute>
              }
            />


            <Route
              path="/billing-manager"
              element={
                <ProtectedRoute allowedRoles={['BILLING_MANAGER']}>
                  <BillingManager />
                </ProtectedRoute>
              }
            />

            <Route
              path="/sample-collection"
              element={
                <ProtectedRoute allowedRoles={['SAMPLE_COLLECTOR']}>
                  <SampleCollector />
                </ProtectedRoute>
              }
            />

            <Route
              path="/parent-dashboard"
              element={
                <ProtectedRoute allowedRoles={['PARENT']}>
                  <ParentDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/coe-dashboard"
              element={
                <ProtectedRoute allowedRoles={['COE', 'ADMIN']}>
                  <COEDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/paper-evaluator-dashboard"
              element={
                <ProtectedRoute allowedRoles={['PAPER_EVALUATOR']}>
                  <PaperEvaluatorDashboard />
                </ProtectedRoute>
              }
            />

            {/* Landing Page */}
            <Route path="/" element={<LandingPage />} />

            {/* 404 Not Found */}
            <Route
              path="*"
              element={
                <div className="not-found">
                  <h1>404 - Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                  <a href="/login">Go to Login</a>
                </div>
              }
            />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;